<ng-container *ngIf="handler">
  <div class="fixed bottom-24 md:bottom-16 right-4">
    <div
      #targetEl
      class="mb-4"></div>
    <button
      pButton
      class="btn-phone text-white bg-primary"
      [rounded]="true"
      (click)="op.toggle($event, targetEl)">
      <img
        src="assets/common/icons/phone-white.svg"
        alt="Contact"
        class="p-4" />
    </button>
    <p-overlayPanel #op>
      <ng-template pTemplate="content">
        <h2 class="text-xl text-darkest font-app-bold mb-4">{{ "contactPopup.Hi" | translate }}</h2>
        <p class="border-b-2 border-lightest pb-4 font-app-regular">
          {{ "contactPopup.needHelp" | translate }}
          {{ "contactPopup.contactMessage" | translate }}
        </p>

        <div class="flex flex-col gap-4">
          <a
            class="flex border-[1px] border-lightest rounded-lg bg-white py-5 px-4 items-center gap-3 hover:border-primary hover:cursor-pointer"
            [routerLink]="['/', NOUS_CONTACTER]">
            <app-svg-icon
              src="assets/common/icons/message.svg"
              class="fill-primary h-[20px] w-[20px]"></app-svg-icon>

            <h3 class="text-darkest font-app-bold">{{ "contactPopup.sendMessage" | translate }}</h3>
          </a>

          <a
            class="flex border-[1px] border-lightest rounded-lg bg-white py-5 px-4 items-center gap-3 hover:border-primary hover:cursor-pointer"
            href="tel:{{ handler.phone }}">
            <app-svg-icon
              src="assets/common/icons/phone.svg"
              class="fill-primary h-[20px] w-[20px]"></app-svg-icon>

            <h3 class="text-darkest font-app-bold">{{ "contactPopup.contactAdvisor" | translate }}</h3>
          </a>
        </div>
      </ng-template>
    </p-overlayPanel>
  </div>
</ng-container>

